import { Container } from './WebinarShared';

const WebinarFooter = ({ leftText, rightText }) => {
  return (
    <footer className="border-t border-white/[0.08] bg-grey-950 py-8">
      <Container className="flex flex-wrap items-center justify-between gap-4 text-[13px] text-white/40">
        {leftText && <div>{leftText}</div>}
        {rightText && <div>{rightText}</div>}
      </Container>
    </footer>
  );
};

export default WebinarFooter;
